import { store } from '@redux/store'
import { resetBillingAddress, setOrder } from '@redux/modules/checkout'
import { updateAddress, updatePayment } from '@services/checkout'
import { getOrder, checkManualAddress } from '../global'
import { getInfoWithGiftAndFinance } from './payment-section'
import { abbreviateState } from '../../geo-location'
import { validateZip } from '../../string-helper'
import { getAddressSpecificBody } from '../shipping-section'

export const setBillingAddressInfo = (info, field = null) => {
  let order = getOrder()
  let billingInfo = info
  if (info.state) {
    info.state = abbreviateState(info.state)
  } else if (field === 'state') {
    // eslint-disable-next-line no-param-reassign
    billingInfo = abbreviateState(info)
  }
  if (field) {
    order = {
      ...order,
      billingAddress: {
        ...order.billingAddress,
        [field]: billingInfo,
      },
    }
  } else {
    order = {
      ...order,
      billingAddress: {
        ...order.billingAddress,
        ...info,
      },
    }
  }
  store.dispatch(setOrder(order))
}

export const validateBillingAddress = async order => {
  const entries = Object.entries({ firstName: '', lastName: '', ...order.payer, ...order.billingAddress })
  let invalidFields = []
  const validateFields = ['address1', 'city', 'firstName', 'lastName', 'state', 'zip']

  entries.forEach(entry => {
    const [entryKey, entryData] = entry
    if (validateFields.includes(entryKey) && (entryData?.trim() ?? '') === '') {
      invalidFields.push(entryKey)
    } else if (entryKey === 'zip' && !validateZip(entryData)) {
      invalidFields.push('zip')
    }
  })

  if (invalidFields.length < 1) {
    invalidFields = await checkManualAddress(order, true)
  }
  return invalidFields
}

// eslint-disable-next-line
export let submitBillingAddress = setBillingState => {
  const order = getOrder()
  setBillingState({ invalidFields: [], loading: true })
  updateAddress(getAddressSpecificBody(order, true))
    .then(orderResponse => {
      let newPaymentInfo = []
      const giftFin = getInfoWithGiftAndFinance()
      if (giftFin && giftFin.length > 0) {
        newPaymentInfo = giftFin
      }
      updatePayment({
        paymentInfo: newPaymentInfo,
        orderId: orderResponse.orderId,
      })
        .then(data => {
          store.dispatch(
            setOrder({
              ...data,
              payer: {
                ...data.payer,
                billingDifferent: true,
                billingSubmitted: true,
              },
              acceptManual: false,
            }),
          )
          setBillingState({ loading: false, invalidFields: [] })
        })
        .catch(err => {
          console.error(err)
          setBillingState({ loading: false })
        })
    })
    .catch(err => {
      console.error(err)
      setBillingState({ loading: false })
    })
}

const initialBillingAddress = {
  address1: '',
  address2: '',
  city: '',
  country_code: 'US',
  state: '',
  zip: '',
}

export const onChangeBillingDifferent = (billingDifferent, orderInput) => {
  // If billingDifferent is false, then user has set billingAddress equal to shipping
  // address, so any manually entered billingAddress info should be removed
  const newPayer = billingDifferent
    ? { ...orderInput.payer, billingDifferent }
    : { billingSubmitted: false, billingDifferent }

  const newCyberSS = orderInput.payer?.billingSubmitted ? { cyberSourceSignature: null } : {}

  const order = {
    ...orderInput,
    ...(billingDifferent ? {} : { billingAddress: { ...initialBillingAddress } }),
    payer: { ...newPayer },
    ...newCyberSS,
  }

  if (billingDifferent) {
    store.dispatch(setOrder(order))
  } else {
    if (orderInput.payer?.billingSubmitted) {
      updateAddress(getAddressSpecificBody(order)) // removes the manually entered billingAddress and payer info
        .then(() => {
          const newPaymentInfo = order.paymentInfo.filter(payment =>
            ['CYBERV4', 'DBUY', 'GIFT'].includes(payment.paymentType),
          )
          updatePayment({ orderId: order.orderId, paymentInfo: newPaymentInfo })
            .then(data => {
              store.dispatch(
                setOrder({
                  ...data,
                  billingAddress: { ...initialBillingAddress },
                  payer: { ...newPayer },
                }),
              )
            })
            .catch(err => {
              console.error(err)
            })
        })
        .catch(err => {
          console.error(err)
        })
    }
    // following is needed since setOrder keeps all existing fields in payer
    store.dispatch(resetBillingAddress({ payer: { ...newPayer }, ...newCyberSS }))
  }
}

export const onBillingStateChange = event => {
  if (event.target.value !== 'none') {
    setBillingAddressInfo(event.target.value, 'state')
  }
}
